module.exports = __webpack_public_path__ + "img/contratos.95fddbf0.png";